var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroSoft365(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g971",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.795,
    height: 15.173,
    viewBox: "0 0 93.795 15.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect20",
    width: 7.21,
    height: 7.21,
    transform: "translate(0 0)",
    fill: "#f25022"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect22",
    width: 7.21,
    height: 7.21,
    transform: "translate(7.96)",
    fill: "#7fba00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect24",
    width: 7.21,
    height: 7.21,
    transform: "translate(0 7.963)",
    fill: "#00a4ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect26",
    width: 7.21,
    height: 7.21,
    transform: "translate(7.96 7.963)",
    fill: "#ffb900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g927",
    transform: "translate(19.72 2.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M282.876,48.443l-.426,1.192h-.024a11.411,11.411,0,0,0-.4-1.179l-2.28-5.718h-2.229v9.092h1.47V46.241c0-.345-.007-.762-.022-1.239-.008-.241-.035-.435-.042-.582h.032c.075.343.152.6.208.778l2.733,6.632h1.028l2.713-6.692a5.943,5.943,0,0,0,.187-.718h.032c-.036.662-.066,1.268-.07,1.633v5.777h1.568V42.738h-2.14Z",
    transform: "translate(-277.514 -42.072)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4",
    width: 1.533,
    height: 6.515,
    transform: "translate(11.316 3.242)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M435.649,40.028a.925.925,0,0,0-.653.256.845.845,0,0,0-.273.639.822.822,0,0,0,.27.627.934.934,0,0,0,.656.25.945.945,0,0,0,.659-.249.818.818,0,0,0,.274-.627.861.861,0,0,0-.267-.632.914.914,0,0,0-.666-.263",
    transform: "translate(-423.551 -39.554)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M477.528,76.875a4.246,4.246,0,0,0-.856-.092,3.78,3.78,0,0,0-1.864.448,3.014,3.014,0,0,0-1.229,1.264,4.021,4.021,0,0,0-.422,1.872,3.458,3.458,0,0,0,.41,1.678,2.884,2.884,0,0,0,1.147,1.16,3.419,3.419,0,0,0,1.676.407,3.667,3.667,0,0,0,1.849-.433l.02-.012v-1.4l-.065.047a2.877,2.877,0,0,1-.75.39,2.268,2.268,0,0,1-.734.143,1.887,1.887,0,0,1-1.435-.559,2.174,2.174,0,0,1-.529-1.549,2.255,2.255,0,0,1,.552-1.59,1.877,1.877,0,0,1,1.437-.593,2.46,2.46,0,0,1,1.459.508l.065.047V77.126l-.021-.012a2.541,2.541,0,0,0-.709-.24",
    transform: "translate(-459.254 -73.698)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M564.388,77.4a1.571,1.571,0,0,0-1.025.368,2.075,2.075,0,0,0-.59.874h-.016V77.514h-1.533v6.515h1.533V80.7a2.324,2.324,0,0,1,.382-1.384,1.172,1.172,0,0,1,.991-.524,1.806,1.806,0,0,1,.461.068,1.168,1.168,0,0,1,.357.145l.065.046V77.5l-.025-.01a1.586,1.586,0,0,0-.6-.091",
    transform: "translate(-541.064 -74.272)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M619.186,76.783a3.4,3.4,0,0,0-2.536.936,3.507,3.507,0,0,0-.916,2.554,3.323,3.323,0,0,0,.895,2.438,3.246,3.246,0,0,0,2.4.9,3.311,3.311,0,0,0,2.486-.949,3.5,3.5,0,0,0,.916-2.529,3.413,3.413,0,0,0-.859-2.457,3.166,3.166,0,0,0-2.385-.9M620.4,81.8a1.554,1.554,0,0,1-1.288.544,1.645,1.645,0,0,1-1.32-.554,2.356,2.356,0,0,1-.474-1.567,2.448,2.448,0,0,1,.474-1.607,1.619,1.619,0,0,1,1.307-.564,1.6,1.6,0,0,1,1.273.539,2.4,2.4,0,0,1,.465,1.595A2.558,2.558,0,0,1,620.4,81.8",
    transform: "translate(-591.699 -73.698)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M723.082,79.632a3.338,3.338,0,0,1-.92-.478.67.67,0,0,1-.186-.5.559.559,0,0,1,.236-.464,1.056,1.056,0,0,1,.66-.186,2.7,2.7,0,0,1,.786.121,2.53,2.53,0,0,1,.686.318l.064.043V77.067l-.025-.01a3.381,3.381,0,0,0-.7-.194,4.275,4.275,0,0,0-.765-.079,2.8,2.8,0,0,0-1.8.556,1.773,1.773,0,0,0-.7,1.445,2.019,2.019,0,0,0,.151.808,1.617,1.617,0,0,0,.464.606,4.042,4.042,0,0,0,.943.528,6.994,6.994,0,0,1,.784.365,1.085,1.085,0,0,1,.345.283.634.634,0,0,1,.1.369c0,.438-.328.651-1,.651a2.752,2.752,0,0,1-.848-.155,3.191,3.191,0,0,1-.869-.44l-.064-.046v1.494l.023.011a3.857,3.857,0,0,0,.823.254,4.41,4.41,0,0,0,.878.1,2.979,2.979,0,0,0,1.9-.559,1.807,1.807,0,0,0,.707-1.48,1.7,1.7,0,0,0-.38-1.119,3.256,3.256,0,0,0-1.292-.822",
    transform: "translate(-688.951 -73.698)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M794.2,76.783a3.4,3.4,0,0,0-2.536.936,3.508,3.508,0,0,0-.916,2.554,3.322,3.322,0,0,0,.895,2.438,3.246,3.246,0,0,0,2.4.9,3.31,3.31,0,0,0,2.486-.949,3.5,3.5,0,0,0,.916-2.529,3.412,3.412,0,0,0-.86-2.457,3.166,3.166,0,0,0-2.386-.9m1.219,5.017a1.554,1.554,0,0,1-1.288.544,1.646,1.646,0,0,1-1.32-.554,2.356,2.356,0,0,1-.474-1.567,2.448,2.448,0,0,1,.474-1.607,1.618,1.618,0,0,1,1.307-.564,1.6,1.6,0,0,1,1.273.539,2.4,2.4,0,0,1,.465,1.595,2.56,2.56,0,0,1-.437,1.615",
    transform: "translate(-754.279 -73.698)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M895.122,37.858v-1.25H893.57V34.665l-.052.016-1.458.446-.029.009v1.472h-2.3v-.82a1.3,1.3,0,0,1,.254-.869.893.893,0,0,1,.711-.291,1.656,1.656,0,0,1,.675.154l.057.025V33.491l-.027-.01a2.624,2.624,0,0,0-.862-.116,2.529,2.529,0,0,0-1.223.294,2.09,2.09,0,0,0-.839.83,2.469,2.469,0,0,0-.3,1.217v.9H887.1v1.25h1.081v5.266h1.551V37.858h2.3V41.2c0,1.378.65,2.076,1.932,2.076a3.155,3.155,0,0,0,.659-.073,1.818,1.818,0,0,0,.48-.152l.02-.012V41.782l-.063.042a1.071,1.071,0,0,1-.312.136,1.188,1.188,0,0,1-.306.052.831.831,0,0,1-.661-.24,1.3,1.3,0,0,1-.21-.837V37.858Z",
    transform: "translate(-843.782 -33.366)",
    fill: "#737373"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g932",
    transform: "translate(74.757 2.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path876",
    d: "M1052.012,49.843V48.465a3.258,3.258,0,0,0,2.047.7,2.413,2.413,0,0,0,1.477-.411,1.311,1.311,0,0,0,.557-1.113q0-1.542-2.416-1.542h-.719V44.925h.686q2.144,0,2.144-1.454,0-1.34-1.671-1.34a2.78,2.78,0,0,0-1.755.651v-1.3a4.58,4.58,0,0,1,2.234-.518,3.042,3.042,0,0,1,1.982.607,1.917,1.917,0,0,1,.745,1.555,2.227,2.227,0,0,1-1.865,2.3v.025a2.463,2.463,0,0,1,1.587.689,2.007,2.007,0,0,1,.583,1.473,2.406,2.406,0,0,1-.939,1.972,3.862,3.862,0,0,1-2.474.746,4.306,4.306,0,0,1-2.2-.487Z",
    transform: "translate(-1052.012 -40.962)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path878",
    d: "M1149.872,47.264a3.221,3.221,0,0,1-.233,1.245,2.808,2.808,0,0,1-1.606,1.606,3.251,3.251,0,0,1-1.211.221,3.1,3.1,0,0,1-1.289-.265,2.779,2.779,0,0,1-1.01-.79,3.8,3.8,0,0,1-.654-1.3,6.377,6.377,0,0,1-.233-1.814,7.472,7.472,0,0,1,.3-2.231,4.9,4.9,0,0,1,.848-1.631,3.565,3.565,0,0,1,2.83-1.34,5.956,5.956,0,0,1,.952.07,2.7,2.7,0,0,1,.693.19v1.321a4.527,4.527,0,0,0-.706-.278,2.974,2.974,0,0,0-.861-.114,2.341,2.341,0,0,0-1,.215,2.23,2.23,0,0,0-.8.632,3.124,3.124,0,0,0-.525,1.024,4.9,4.9,0,0,0-.194,1.4h.039a2.088,2.088,0,0,1,.8-.708,2.619,2.619,0,0,1,1.2-.259,2.9,2.9,0,0,1,1.094.2,2.219,2.219,0,0,1,.835.556,2.423,2.423,0,0,1,.538.885,3.416,3.416,0,0,1,.188,1.169Zm-1.515.12a2.472,2.472,0,0,0-.1-.714,1.433,1.433,0,0,0-.285-.55,1.232,1.232,0,0,0-.479-.36,1.649,1.649,0,0,0-.673-.126,1.605,1.605,0,0,0-.687.139,1.487,1.487,0,0,0-.492.354,1.516,1.516,0,0,0-.3.506,1.789,1.789,0,0,0-.1.582,2.587,2.587,0,0,0,.091.664,2.064,2.064,0,0,0,.292.613,1.642,1.642,0,0,0,.492.461,1.405,1.405,0,0,0,.719.177,1.532,1.532,0,0,0,.654-.133,1.3,1.3,0,0,0,.473-.367,1.57,1.57,0,0,0,.292-.55A2.252,2.252,0,0,0,1148.356,47.384Z",
    transform: "translate(-1137.124 -40.962)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path880",
    d: "M1242.731,51.953v-1.41a3.34,3.34,0,0,0,1.852.6,2.341,2.341,0,0,0,1.522-.468,1.547,1.547,0,0,0,.576-1.258,1.4,1.4,0,0,0-.589-1.2,2.794,2.794,0,0,0-1.677-.43q-.376,0-1.522.076l.33-4.766h4.573v1.252h-3.322l-.156,2.269q.447-.025.81-.025a3.244,3.244,0,0,1,2.28.74,2.6,2.6,0,0,1,.81,2.023,2.739,2.739,0,0,1-.926,2.162,3.7,3.7,0,0,1-2.532.809A4.284,4.284,0,0,1,1242.731,51.953Z",
    transform: "translate(-1229.178 -42.945)",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroSoft365);
export default __webpack_public_path__ + "static/media/MicroSoft365.75ea92d2f68475c80ad8a6635638e3c9.svg";
export { ForwardRef as ReactComponent };